import React from 'react';
import { SparklesIcon, HeartIcon, TrendingUpIcon, ZapIcon, StarIcon, CompassIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <SparklesIcon className="w-8 h-8" data-id="element-4" />,
    title: 'Duerme profundamente cada noche',
    description: 'Calma tu mente y descansa como mereces'
  }, {
    icon: <HeartIcon className="w-8 h-8" data-id="element-5" />,
    title: 'Recupera tu energía femenina',
    description: 'Reconecta con tu poder interior'
  }, {
    icon: <TrendingUpIcon className="w-8 h-8" data-id="element-6" />,
    title: 'Aumenta tu autoestima',
    description: 'Descubre la bichota que siempre has sido'
  }, {
    icon: <ZapIcon className="w-8 h-8" data-id="element-7" />,
    title: 'Domina tus finanzas con claridad',
    description: 'Ahorra sin sacrificar tu felicidad'
  }, {
    icon: <StarIcon className="w-8 h-8" data-id="element-8" />,
    title: 'Conecta con tu poder interno',
    description: 'Vive con confianza y autenticidad'
  }, {
    icon: <CompassIcon className="w-8 h-8" data-id="element-9" />,
    title: 'Vive con propósito, paz y dirección',
    description: 'Encuentra tu camino con claridad'
  }];
  return <section className="w-full py-20 bg-gradient-to-b from-white to-pink-50" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-13">
            💛 Beneficios Clave
          </h2>
          <p className="text-xl text-gray-600" data-id="element-14">
            Todo lo que vas a lograr con este bundle transformador
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-15">
          {benefits.map((benefit, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-16">
              <div className="text-magenta-500 mb-4" data-id="element-17">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-18">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-19">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}